exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CommentBox-40b53039{margin-bottom:60px}.textarea-5708f8a0{resize:none;border:1px solid #DEDEDE;outline:none;color:#5C5C5C;width:100%;padding:20px;min-height:100px;box-sizing:border-box}.textarea-5708f8a0:focus{outline:none}.textarea-5708f8a0:disabled{color:#8f8f8f;background:#ddd}.submitButton-2c6ab157{float:right;margin-top:15px}\n", ""]);

// Exports
exports.locals = {
	"CommentBox": "CommentBox-40b53039",
	"textarea": "textarea-5708f8a0",
	"submitButton": "submitButton-2c6ab157"
};